import { Box, Button, Chip, Typography } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { Client } from "../../types/client";

interface MinimizedClientViewProps {
  selectedClients: Client[];
  selectedCount: number;
  onExpand: () => void;
}

const MinimizedClientView = ({
  selectedClients,
  selectedCount,
  onExpand,
}: MinimizedClientViewProps) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 2,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: 1,
          flex: 1,
          alignItems: "center",
        }}
      >
        {selectedClients.map((client) => (
          <Chip
            key={client.id}
            label={client.name}
            size="small"
            sx={{
              backgroundColor: "rgba(0, 128, 128, 0.08)",
              border: "1px solid rgba(0, 128, 128, 0.3)",
              color: "primary.main",
              fontWeight: 500,
            }}
          />
        ))}
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ ml: 1, mt: 0.4 }}
        >
          ({selectedCount} selected)
        </Typography>
      </Box>
      <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
        <Button
          size="small"
          startIcon={<EditIcon />}
          onClick={onExpand}
          variant="outlined"
        >
          Edit Selection
        </Button>
      </Box>
    </Box>
  );
};

export default MinimizedClientView;
